import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class AllInPayCashierFilingAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getAllInPayCashierFilingList', {
      url: '/admin/shop/cashier/termList',
      name: 'list',
      label: '列表'
    }],
    ['addAllInPayCashierFiling', {
      url: '/admin/shop/cashier/addTerm',
      name: 'add',
      label: '添加'
    }],
    ['updateAllInPayCashierFiling', {
      url: '/admin/shop/cashier/updateTerm',
      name: 'edit',
      label: '编辑'
    }],
    ['syncCashierFiling', {
      url: '/admin/shop/cashier/queryTerm',
      name: 'sync-cashier-filing',
      label: '同步通联收银台报备'
    }],

    ['getSimpleCashierShopInfo', {
      url: '/admin/shop/detail',
      name: 'get-cashier-shop-simple-info',
      label: '获取收银台店铺简洁信息'
    }],

    ['getFilingCashierInfo', {
      url: '/admin/shop/cashier/viewTerm',
      name: 'get-filing-cashier-info',
      label: '获取已报备收银台信息'
    }],

    ['getPlatformProvinceList', {
      url: '/admin/allinNumber/provinces',
      name: 'get-platform-province-list',
      label: '获取平台下的省份列表'
    }],

    ['getPlatformProvinceMerchantList', {
      url: '/admin/allinNumber/provinceMerchant',
      name: 'get-platform-province-merchant-list',
      label: '获取平台以及省份下的商户号列表'
    }],

    ['switchFilingTerminal', {
      url: '/admin/shop/cashier/switch',
      name: 'switch-filing-terminal',
      label: '切换收银台报备终端'
    }],


    ['allFilingCheckSyncQuery', {
      url: '/admin/shop/cashier/oneKeyTermQuery',
      name: 'all-filing-check-sync-query',
      label: '一键报备查询同步'
    }],

    ['allCashierFilingTerm', {
      url: '/admin/shop/cashier/oneKeyTerm',
      name: 'all-cashier-filing-term',
      label: '一键报备'
    }],
    // ['getFilingProviceList', {
    //   url: '/admin/city/allinpay/province',
    //   name: 'get-filing-provice-list',
    //   label: '获取报备省列表'
    // }],
    // ['getFilingCityOrAreaList', {
    //   url: '/admin/city/allinpay/city',
    //   name: 'get-filing-city-or-area-list',
    //   label: '获取报备市或区列表'
    // }],
    // ['deleteAllInPayCashierFiling', {
    //   url: '/admin/sellerMachine/delete',
    //   name: 'delete',
    //   label: '删除'
    // }],
    // ['searchVenueList', {
    //   url: '/admin/coupons/shop/list',
    //   name: 'shop-list',
    //   label: '店铺列表',
    //   // hidden: true
    // }],
  ])

  // 收银台报备列表
  public getAllInPayCashierFilingList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getAllInPayCashierFilingList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 修改收银台报备
  public updateAllInPayCashierFiling(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateAllInPayCashierFiling').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加收银台报备
  public addAllInPayCashierFiling(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addAllInPayCashierFiling').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 同步收银台报备
  public syncCashierFiling(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('syncCashierFiling').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 获取收银台店铺简洁信息
  public getSimpleCashierShopInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getSimpleCashierShopInfo').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 获取已报备收银台信息
  public getFilingCashierInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getFilingCashierInfo').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 获取平台下的省份列表
  public getPlatformProvinceList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getPlatformProvinceList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 获取平台以及省份下的商户号列表
  public getPlatformProvinceMerchantList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getPlatformProvinceMerchantList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 切换收银台报备终端
  public switchFilingTerminal(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('switchFilingTerminal').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }


  // 一键报备查询同步
  public allFilingCheckSyncQuery(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('allFilingCheckSyncQuery').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 一键报备
  public allCashierFilingTerm(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('allCashierFilingTerm').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }





  // 删除收银台报备
  // public deleteAllInPayCashierFiling(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteAllInPayCashierFiling').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // // 搜索店铺列表
  // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('searchVenueList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
}